export default "__VITE_ASSET__BQjUoqCu__"